import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";

import * as fromCartProperties from "./cart-properties.reducer";
import * as fromCoursesProperties from "./courses.reducer";

// this is the interface (type) for our cart.module
// and creates the structure for our state tree
export interface CartState {
    cartProperties: fromCartProperties.CartPropertiesState;
    classesForSubject: fromCoursesProperties.CartClassesListState;
}

// register the reducers
export const reducers: ActionReducerMap<CartState> = {
    cartProperties: fromCartProperties.reducer,
    classesForSubject: fromCoursesProperties.reducer
};

// This const creates the base level of our state object
export const getCartState = createFeatureSelector<CartState>("cartModule");
